// Platform brand color — Amazon Ads "Squid Ink" nav background
// Not available as a Storm UI theme token; sourced from D16G platform (AUI nav row)
export const AMAZON_NAV_INKWELL = '#232F3E';

// Shared common constants
export const SHARED_CONSTANTS = {
  SUCCESS_SNACKBAR_CLEAR_TIME: 3000,
  SEARCH_DEBOUNCE_TIME: 300,
  MIN_CHARACTER_LIMIT_TO_TRIGGER_SEARCH: 2,
  STALE_TIME_FOR_REACT_QUERY: 300000
};


export const TAG_TYPES = {
  INPUT_TAG_TYPE: 'input',
  DROPDOWN_TAG_TYPE: 'dropdown',
}

export const KEY_PRESS_FUNCTIONS = {
  ARROW_DOWN: 'ArrowDown',
  ARROW_UP: 'ArrowUp',
  ENTER: 'Enter',
  ESCAPE: 'Escape'
}

export const SIDE_NAVIGATION_RESET_PARAM_KEY = 'reset'
export const SIDE_NAVIGATION_RESET_PARAM = { [SIDE_NAVIGATION_RESET_PARAM_KEY]: 'true' };
